import {
	APIS_REQUEST_GET,
	APIS_RESPONSE_GET_SUCCESS,
	APIS_RESPONSE_GET_FAIL,
	PC_LIST,
	PC_LIST_SUCCESS,
	PC_LIST_FAIL,
	PC_STOP_SUCCESS,
	PC_STOP,
	PC_STOP_FAIL,
	PC_DELETE_FAIL,
	PC_DELETE_SUCCESS,
	PC_DELETE,
	PC_ADD,
	PC_ADD_SUCCESS,
	PC_ADD_FAIL,
	PC_DOWNLOAD,
	PC_DOWNLOAD_SUCCESS,
	PC_DOWNLOAD_FAIL,
    PC_RESET,
} from '../../../constants/maintenance/systemHealth/apisConstants';

export const apisShReducer = (state = { apis: {} }, action) => {
	switch (action.type) {
		case APIS_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case APIS_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				apis: action.payload,
			};
		case APIS_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const pcReducer = (
	state = {
		packetCaptureList: [],
		pcTotalCount: 0,
		pcAddSuccess: null,
		pcAddError: null,

		pcDeleteSuccess: null,
		pcDeleteError: null,

		pcStopSuccess: null,
		pcStopError: null,

		pcDownloadSuccess: null,
		pcDownloadError: null,
	},
	action
) => {
	switch (action.type) {
		case PC_LIST:
			return {
				...state,
				loading: true,
			};
		case PC_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				packetCaptureList: action.payload?.results || [],
				pcTotalCount: action.payload?.count || 0,
			};
		case PC_LIST_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case PC_ADD:
			return {
				...state,
				loading: true,
				pcAddSuccess: null,
				pcAddError: null,
			};
		case PC_ADD_SUCCESS:
			return {
				...state,
				loading: false,
				pcAddSuccess: action.payload,
				pcAddError: null,
			};
		case PC_ADD_FAIL:
			return {
				...state,
				loading: false,
				pcAddSuccess: null,
				pcAddError: action.payload,
			};
		case PC_DOWNLOAD:
			return {
				...state,
				loading: true,
				pcDownloadSuccess: null,
				pcDownloadError: null,
			};
		case PC_DOWNLOAD_SUCCESS:
			return {
				...state,
				loading: false,
				pcDownloadSuccess: action.payload,
				pcDownloadError: null,
			};
		case PC_DOWNLOAD_FAIL:
			return {
				...state,
				loading: false,
				pcDownloadSuccess: null,
				pcDownloadError: action.payload,
			};
		case PC_DELETE:
			return {
				...state,
				loading: true,
				pcDeleteSuccess: null,
				pcDeleteError: null,
			};
		case PC_DELETE_SUCCESS:
			return {
				...state,
				loading: false,
				pcDeleteSuccess: action.payload,
				pcDeleteError: null,
			};
		case PC_DELETE_FAIL:
			return {
				...state,
				loading: false,
				pcDeleteSuccess: null,
				pcDeleteError: action.payload,
			};
		case PC_STOP:
			return {
				...state,
				loading: true,
				pcStopSuccess: null,
				pcStopError: null,
			};
		case PC_STOP_SUCCESS:
			return {
				...state,
				loading: false,
				pcStopSuccess: action.payload,
				pcStopError: null,
			};
		case PC_STOP_FAIL:
			return {
				...state,
				loading: false,
				pcStopSuccess: null,
				pcStopError: action.payload,
			};
        case PC_RESET:
            return {
                ...state,
                pcAddSuccess: null,
                pcAddError: null,
                pcDeleteSuccess: null,
                pcDeleteError: null,
                pcStopSuccess: null,
                pcStopError: null,
                pcDownloadSuccess: null,
                pcDownloadError: null,
            }
		default:
			return state;
	}
};

export const pcAddReducer = (state = { packetCaptureAdd: {} }, action) => {
	switch (action.type) {
		case PC_ADD:
			return {
				...state,
				loading: true,
			};
		case PC_ADD_SUCCESS:
			return {
				...state,
				loading: false,
				packetCaptureAdd: action.payload,
			};
		case PC_ADD_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const pcstopreducer = (state = { packetCapture: {} }, action) => {
	switch (action.type) {
		case PC_STOP:
			return {
				...state,
				loading: true,
			};
		case PC_STOP_SUCCESS:
			return {
				...state,
				loading: false,
				packetCapture: action.payload,
			};
		case PC_STOP_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const pcdeletereducer = (state = { packetCapture: {} }, action) => {
	switch (action.type) {
		case PC_DELETE:
			return {
				...state,
				loading: true,
			};
		case PC_DELETE_SUCCESS:
			return {
				...state,
				loading: false,
				packetCapture: action.payload,
			};
		case PC_DELETE_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
